import { render, staticRenderFns } from "./add-field.vue?vue&type=template&id=79e5441c&scoped=true&"
import script from "./add-field.vue?vue&type=script&lang=js&"
export * from "./add-field.vue?vue&type=script&lang=js&"
import style0 from "./add-field.vue?vue&type=style&index=0&id=79e5441c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e5441c",
  null
  
)

export default component.exports